import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";
import { apiFetch } from "../lib/api.js";

const STATUS_FILTERS = [
  { value: "", label: "All" },
  { value: "failed", label: "Failed" },
  { value: "recovered", label: "Recovered" },
  { value: "sent", label: "Sent" },
  { value: "pending", label: "Pending" },
];

function formatDate(value) {
  if (!value) return "-";
  return new Date(value).toLocaleString();
}

export default function Admin() {
  const { user } = useAuth();
  const [entries, setEntries] = useState(null);
  const [status, setStatus] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user?.isAdmin) return;
    const query = status ? `?status=${status}` : "";
    apiFetch(`/admin/digest-log${query}`)
      .then((data) => setEntries(data.entries))
      .catch((e) => setError(e.message));
  }, [user, status]);

  if (!user?.isAdmin) {
    return (
      <div className="page">
        <p className="empty-state">Not found.</p>
      </div>
    );
  }

  return (
    <div className="page-wide">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        ADMIN
      </div>
      <h1 style={{ marginBottom: 8 }}>Weekly digest delivery</h1>
      <p style={{ color: "var(--muted)", marginBottom: 32 }}>
        Every claim/send attempt made by the weekly digest scheduler. Look here for members
        whose digest failed or was recovered after a crash, so you can follow up directly.
      </p>

      <div style={{ display: "flex", gap: 8, marginBottom: 24, flexWrap: "wrap" }}>
        {STATUS_FILTERS.map((f) => (
          <button
            key={f.value}
            type="button"
            className={`filter-tab${status === f.value ? " active" : ""}`}
            onClick={() => setStatus(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {error && <p style={{ color: "var(--error)" }}>{error}</p>}

      {entries && entries.length === 0 && (
        <p className="empty-state">No digest log entries for this filter.</p>
      )}

      {entries && entries.length > 0 && (
        <div className="card">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ textAlign: "left", borderBottom: "1px solid var(--hairline)" }}>
                <th style={{ padding: "8px 12px" }}>Member</th>
                <th style={{ padding: "8px 12px" }}>Week of</th>
                <th style={{ padding: "8px 12px" }}>Status</th>
                <th style={{ padding: "8px 12px" }}>Claimed at</th>
                <th style={{ padding: "8px 12px" }}>Resolved at</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id} style={{ borderBottom: "1px solid var(--hairline)" }}>
                  <td style={{ padding: "8px 12px" }}>{e.email}</td>
                  <td style={{ padding: "8px 12px" }}>{formatDate(e.weekOf)}</td>
                  <td style={{ padding: "8px 12px" }}>
                    <span
                      className="band-label"
                      style={{
                        color:
                          e.status === "failed" ? "var(--error)"
                          : e.status === "recovered" ? "var(--bronze-lit)"
                          : "var(--muted)",
                      }}
                    >
                      {e.status}
                    </span>
                  </td>
                  <td style={{ padding: "8px 12px" }}>{formatDate(e.claimedAt)}</td>
                  <td style={{ padding: "8px 12px" }}>{formatDate(e.resolvedAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
